import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MessageOutboundSettingsComponent from './settings.component';

const messageOutboundModule = angular.module('tinaba.components.messageOutbound.settings', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('messageOutbound.settings', {
    url: '/settings',
    template: '<message-outbound-settings></message-outbound-settings>'
  });
})

.component('messageOutboundSettings', MessageOutboundSettingsComponent);

export default messageOutboundModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/settings/settings.js
 **/